export default [
  {
    id: 0,
    name: 'No notice',
  },
  {
    id: 2,
    name: '< 2 hrs notice',
  },
  {
    id: 6,
    name: '< 6 hrs notice',
  },
  {
    id: 12,
    name: '< 12 hrs notice',
  },
  {
    id: 24,
    name: '< 24 hrs notice',
  },
  {
    id: 48,
    name: '< 48 hrs notice',
  },
  {
    id: 168,
    name: '< 168 hrs notice',
  },
];
